import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '../stores/auth.store'

// 관리
import CastroomAdminView from '../views/admin/CastroomAdminView.vue'
import RecordingAdminView from '../views/admin/RecordingAdminView.vue'
import RtspsAdminView from '../views/admin/RtspsAdminView.vue'
import AuthAdminView from '../views/admin/AuthAdminView.vue'

// 기능테스트
import PlayerTestView from '../views/test/PlayerTestView.vue'
import CasterTestView from '../views/test/CasterTestView.vue'

// 외부연동
import CastServiceView from '../views/service/CastServiceView.vue'
import PlayServiceView from '../views/service/PlayServiceView.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      redirect: '/test/player'
    },

    // 관리 (로그인 필요)
    {
      path: '/admin/castroom',
      name: 'admin-castroom',
      component: CastroomAdminView,
      meta: { requiresAuth: true }
    },
    {
      path: '/admin/recording',
      name: 'admin-recording',
      component: RecordingAdminView,
      meta: { requiresAuth: true }
    },
    {
      path: '/admin/auth',
      name: 'admin-auth',
      component: AuthAdminView,
      meta: { requiresAuth: true }
    },
    {
      path: '/admin/rtsps',
      name: 'admin-rtsps',
      component: RtspsAdminView,
      meta: { requiresAuth: true }
    },

    // 기능테스트
    {
      path: '/test/player',
      name: 'test-player',
      component: PlayerTestView
    },
    {
      path: '/test/caster',
      name: 'test-caster',
      component: CasterTestView
    },

    // 외부연동
    {
      path: '/service/cast',
      name: 'service-cast',
      component: CastServiceView,
      meta: { hideNav: true }
    },
    {
      path: '/service/play',
      name: 'service-play',
      component: PlayServiceView,
      meta: { hideNav: true }
    },

    // AS-IS 경로 redirect (하위호환)
    { path: '/publisher', redirect: '/test/caster' },
    { path: '/screen', redirect: '/test/caster' },
    { path: '/player', redirect: '/test/player' },
    { path: '/castroom', redirect: '/admin/castroom' },
    { path: '/test/rtsps', redirect: '/admin/rtsps' },
    { path: '/rtsps', redirect: '/admin/rtsps' },
    { path: '/rtsp', redirect: '/admin/rtsps' },
  ]
})

// 라우터 가드: /admin/* 페이지는 로그인 필요
router.beforeEach((to) => {
  if (to.meta?.requiresAuth) {
    const authStore = useAuthStore()
    if (!authStore.isLoggedIn) {
      return '/test/player'
    }
  }
})

export default router
